import React, { useState, useEffect } from "react";
import styles from "../assets/css/UserList.module.css";
import { BlockToggle } from "./UsersList";
import { defaultProfile, togleA, togleB, view } from "../assets/img";
import { NavLink, useNavigate } from "react-router-dom";
import common from "../assets/css/common.module.css";
import { Loader } from "../../components/Loader";
import { nextArow, swipetestleft } from "../../assets/images";
import { postData1 } from "../../services";
import { Pagination } from "../Common";

export const ScheduledMeetings = () => {
  const [MeetlistData, setMeetListData] = useState([]);
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);
  const [currPage, setCurrPage] = useState(1);
  const [paging, setPaging] = useState({});
  const [prevPage, setPrevPage] = useState(1);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("asc");

  const sortData = (data, column, direction) => {
    const sortedData = [...data];
    if (column) {
      sortedData.sort((a, b) => {
        if (a[column] < b[column]) return direction === "asc" ? -1 : 1;
        if (a[column] > b[column]) return direction === "asc" ? 1 : -1;
        return 0;
      });
    }
    return sortedData;
  };

  const handleSort = (column) => {
    const newDirection = sortColumn === column && sortDirection === "asc" ? "desc" : "asc";
    setSortColumn(column);
    setSortDirection(newDirection);
  };

  const renderSortIcon = (column) => {
    if (sortColumn !== column) return null;
    return sortDirection === "asc" ? (
      <span>&#8593;</span> // Up arrow
    ) : (
      <span>&#8595;</span> // Down arrow
    );
  };

  const updatePage = (e) => {
    let name = e.currentTarget.name;
    if (name === "prev") {
      setCurrPage(currPage === 1 ? 1 : currPage - 1);
      setPrevPage(currPage);
    } else if (name === "next") {
      setCurrPage(currPage === paging?.total_pages ? currPage : currPage + 1);
      setPrevPage(currPage);
    } else {
      setCurrPage(parseInt(e.currentTarget.innerHTML));
    }
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleView = (e, data) => {
    navigate("/admin/managemeetings/view/", { state: data });
  };

  useEffect(() => {
    (async () => {
      const config = { _page: currPage, _limit: 8 };
      const res = await postData1(
        "admin/schedulemeeting_list/",
        config,
        true,
        true
      );
      const sortedData = sortData(res?.data?.data, sortColumn, sortDirection);
      setMeetListData(sortedData);
      setPaging({
        total: res?.data?.total,
        total_pages: res?.data?.total_pages,
      });
      setLoader(false);
    })();
  }, [currPage, sortColumn, sortDirection]);

  return (
    <section className={styles.userListCont}>
      <div className={styles.listHead}>
        <h1>MEETING MANAGEMENT</h1>
      </div>
      <div className={styles.dataItems}>
        <div className={styles.itemHead}>
          <span onClick={() => handleSort("id")}>
            MEET ID {renderSortIcon("id")}
          </span>
          <span onClick={() => handleSort("product")}>
            PRODUCT {renderSortIcon("product")}
          </span>
          <span onClick={() => handleSort("buyer_firstname")}>
            BUYER {renderSortIcon("buyer_firstname")}
          </span>
          <span onClick={() => handleSort("seller_firstname")}>
            SELLER {renderSortIcon("seller_firstname")}
          </span>
          <span onClick={() => handleSort("date")}>
            SCHEDULE DATE {renderSortIcon("date")}
          </span>
          <span onClick={() => handleSort("duration")}>
            DURATION {renderSortIcon("duration")}
          </span>
          <span>DETAIL</span>
        </div>

        {MeetlistData.map((data, index) => (
          <div className={styles.itemData} key={index}>
            <span>{data?.id}</span>
            <span>{data?.product}</span>
            <span>{data?.buyer_firstname}</span>
            <span>{data?.seller_firstname}</span>
            <span>{data?.date}</span>
            <span>{data?.duration}</span>
            <span
              onClick={(e) => handleView(e, data)}
              style={{ cursor: "pointer", color: "blue" }}
            >
              View
            </span>
          </div>
        ))}
      </div>
      <Pagination
        total={paging?.total}
        perPage={8}
        currPage={currPage}
        prevPage={prevPage}
        tPage={paging?.total_pages}
        updatePage={updatePage}
      />
      {loader && <Loader />}
    </section>
  );
};
